<div class="inner-cell">
  <a (click)="onClick($event)"
     href="">{{cellValue}}
  </a>
</div>
